import {useNavigate, useParams} from "react-router-dom";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {Card} from "@mui/material";
import Meta from "../common/Meta";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import MDButton from "../../components/MDButton";
import Icon from "@mui/material/Icon";
import Footer from "../Footer";
import NotificationItem from "../Items/NotificationItem";
import Menu from "@mui/material/Menu";
import {
  archiveEmployeeTimeEntry,
  getCompanyExtApp,
  getEmployeeSchedule,
  getEmployeeTimecard,
  getMyCompanyEmployee,
  saveEmployee,
  saveEmployeeTimeEntry
} from "../common/api/WebApi";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import moment from "moment";
import {formatDate, formatTime} from "../common/Utils";
import ManageTimeEntryModal from "./ManageTimeEntryModal";
import ManageEmployeeModal from "./ManageEmployee";
import {CONSTANTS} from "../common/constants";
import MangeSquareHomeLocation from "../inventory/ManageSquareHomeLocation";
import Confirm from "../common/Confirm";

export default function ViewEmployee(props) {

  const navigate = useNavigate();
  const [employeeGuid, setEmployeeGuid] = useState();

  let {guid} = useParams();
  const [context, setContext] = useContext(AppContext);
  const [companyAdmin, setCompanyAdmin] = useState(false);
  const [companyReady, setCompanyReady] = useState(false);
  const [simpleTimeEntries, setSimpleTimeEntries] = useState(false);

  const [simpleTimeEntry, setSimpleTimeEntry] = useState(false);

  useEffect(() => {
    if (simpleTimeEntries && !companyAdmin) {
      setSimpleTimeEntry(true);
    }
  }, [simpleTimeEntries, companyAdmin])

  useEffect(() => {
    if (!context?.sessionUser?.company) {
      return;
    }
    setCompanyAdmin(context?.sessionUser?.companyAdmin);
    setSimpleTimeEntries('true' === context?.sessionUser?.company?.preferences['simple_time_clock_entry']);
    setCompanyReady(true);

  }, [context]);

  useEffect(() => {
    if (guid) {
      setEmployeeGuid(guid);
    } else {
      setEmployeeGuid(context?.sessionUser?.guid)
    }
  }, [guid]);


  const [saving, setSaving] = useState(false);
  const [manageEmployee, setManageEmployee] = useState(false);
  const [employee, setEmployee] = useState();

  const [editEmployee, setEditEmployee] = useState();

  const [timecard, setTimecard] = useState();
  const [schedule, setSchedule] = useState();
  const [timeEntry, setTimeEntry] = useState();
  const [confirmation, setConfirmation] = useState(null);

  const [manageTimeEntry, setManageTimeEntry] = useState(false);
  const [timeRequest, setTimeRequest] = useState();
  const [scheduleRequest, setScheduleRequest] = useState();

  const [timeEntryOptions, setTimeEntryOptions] = useState([]);
  const [scheduleOptions, setScheduleOptions] = useState([]);
  const [squareConnected, setSquareConnected] = useState(false);
  const [companyExtApplication, setCompanyExtApplication] = useState();
  const [manageHomeLocation, setManageHomeLocation] = useState(false);

  const [deleteTimeEntry, setDeleteTimeEntry] = useState(false);


  const getCompanyExtAppData = () => {
    getCompanyExtApp().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCompanyExtApplication(result);
        if (result?.type == CONSTANTS.EXT_APPLICATION.SQUARE) {
          setSquareConnected(true);
        }
      }
    });
  }

  useEffect(() => {
    getCompanyExtAppData();
  }, [])

  useEffect(() => {
    if (!companyReady) {
      return;
    }

    let _options = [];
    let _scheduleOptions = [];
    let day = new Date();
    day.setHours(0, 0, 0, 0);

    for (let i = 0; i < 4; i++) {
      let currentDate = moment(day);
      let weekStart = currentDate.clone().startOf('week');
      weekStart.add(-7 * i, 'days');
      _options.push(
        {
          label: 'Week of ' + weekStart.format(CONSTANTS.DISPLAY_DATE_FORMAT),
          value: weekStart.format('YYYY-MM-DD'),
          type: 'week'
        }
      )
    }

    for (let i = 0; i < 12; i++) {
      let currentDate = moment(day);
      let weekStart = currentDate.clone().startOf('month');
      weekStart.add(-1 * i, 'months');
      _options.push(
        {
          label: 'Month of ' + weekStart.format(CONSTANTS.DISPLAY_DATE_FORMAT),
          value: weekStart.format('YYYY-MM-DD'),
          type: 'month'
        }
      )
    }


    let currentDate = moment(day);
    let weekStart = currentDate.clone().startOf('week');
    weekStart.add(-7, 'days');
    _scheduleOptions.push(
      {
        label: 'Week of ' + weekStart.format(CONSTANTS.DISPLAY_DATE_FORMAT),
        value: weekStart.format('YYYY-MM-DD'),
        type: 'week'
      }
    )

    for (let i = 0; i < 8; i++) {
      let currentDate = moment(day);
      let weekStart = currentDate.clone().startOf('week');
      weekStart.add(7 * i, 'days');
      _scheduleOptions.push(
        {
          label: 'Week of ' + weekStart.format(CONSTANTS.DISPLAY_DATE_FORMAT),
          value: weekStart.format('YYYY-MM-DD'),
          type: 'week'
        }
      )
    }

    for (let i = 0; i < 12; i++) {
      let currentDate = moment(day);
      let weekStart = currentDate.clone().startOf('month');
      weekStart.add(1 * i, 'months');
      _scheduleOptions.push(
        {
          label: 'Month of ' + weekStart.format(CONSTANTS.DISPLAY_DATE_FORMAT),
          value: weekStart.format('YYYY-MM-DD'),
          type: 'month'
        }
      )
    }

    setTimeEntryOptions(_options);
    setTimeRequest(_options[0]);

    setScheduleOptions(_scheduleOptions);
    setScheduleRequest(_scheduleOptions[1]);

  }, [companyReady]);

  useEffect(() => {
    getEmployeeTimecardFn();
  }, [timeRequest]);

  useEffect(() => {
    getEmployeeScheduleFn();
  }, [scheduleRequest]);

  const startManageEmployeeFn = (e) => {
    setEditEmployee({...e});
    setManageEmployee(true);
  };

  const handleSaveTimeEntry = (timeEntry) => {
    setSaving(true);
    let _timeEntry = {...timeEntry};
    _timeEntry.guid = employeeGuid;
    _timeEntry.timeEntryId = timeEntry.timeEntryId;

    saveEmployeeTimeEntry(_timeEntry).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setManageTimeEntry(false);
        if (timeEntry?.scheduledTime) {
          getEmployeeScheduleFn();
        } else {
          getEmployeeTimecardFn();
        }
      }
      setSaving(false);
    });

  }

  const handleCloseTimeEntry = () => {
    setManageTimeEntry(false);
  }

  useEffect(() => {
    if (!employeeGuid) {
      return;
    }
    getEmployeeFn();
  }, [employeeGuid]);

  const getEmployeeFn = () => {
    getMyCompanyEmployee(employeeGuid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setEmployee(result);
      }
    });
  }

  const getEmployeeScheduleFn = () => {
    let _req = {};

    if (!scheduleRequest?.type) {
      return;
    }

    if (scheduleRequest.type === 'week') {
      let startOfWeek = moment(scheduleRequest.value).startOf('week');
      let endOfWeek = moment(scheduleRequest.value).endOf('week');
      _req.startDate = startOfWeek.toDate();
      _req.endDate = endOfWeek.toDate();
    } else if (scheduleRequest.type === 'month') {
      let startOfMonth = moment(scheduleRequest.value).startOf('month');
      let endOfMonth = moment(scheduleRequest.value).endOf('month');
      _req.startDate = startOfMonth.toDate();
      _req.endDate = endOfMonth.toDate();
    }

    _req.guid = employeeGuid;

    getEmployeeSchedule(_req).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setSchedule(result);
      }
    });
  }

  const getEmployeeTimecardFn = () => {
    let _req = {};

    if (!timeRequest?.type) {
      return;
    }

    if (timeRequest.type === 'week') {
      let startOfWeek = moment(timeRequest.value).startOf('week');
      let endOfWeek = moment(timeRequest.value).endOf('week');
      _req.startDate = startOfWeek.toDate();
      _req.endDate = endOfWeek.toDate();
    } else if (timeRequest.type === 'month') {
      let startOfMonth = moment(timeRequest.value).startOf('month');
      let endOfMonth = moment(timeRequest.value).endOf('month');
      _req.startDate = startOfMonth.toDate();
      _req.endDate = endOfMonth.toDate();
    }

    _req.guid = employeeGuid;

    getEmployeeTimecard(_req).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setTimecard(result);
      }
    });
  }

  const myRefs = useRef([]);
  const [renderIndex, setRenderIndex] = useState(1);

  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };


  const defaultTime = (hours) => {
    let d = new Date();
    d.setHours(hours);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    let dateSelected = scheduleRequest?.value;
    if (dateSelected) {
      let dates = dateSelected.split("-");
      d.setDate(dates[2]);
      d.setMonth(parseInt(dates[1], 10) - 1);
      d.setFullYear(dates[0]);
    }

    return d;
  }

  const addTimeEntry = (e, isSchedule) => {
    setTimeEntry({
      startDate: isSchedule ? defaultTime(8) : new Date(),
      endDate: isSchedule ? defaultTime(18) : new Date(),
      timeEntryId: null,
      scheduledTime: isSchedule
    });
    setManageTimeEntry(true);
  }

  const handleSaveEmployee = async (employee) => {
    setSaving(true);

    let result = await saveEmployee(employee);
    setSaving(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setManageEmployee(false);
      getEmployeeFn();
    }
  };

  const canEdit = (entry) => {
    if (!entry.endDate) {
      return false;
    }
    const now = new Date();
    const start = new Date(entry.startDate);
    const startTime = now.getTime() - (21 * 60 * 60 * 24 * 1000);
    return start.getTime() > startTime;
  }

  const handleDeleteTimeEntry = (entry) => {
    let _entry = {...entry}
    _entry.timeEntryId = entry.id;
    archiveEmployeeTimeEntry(_entry).then((resp)=>{
      setSaving(false);
      setConfirmation(null);
      setDeleteTimeEntry(false);
      getEmployeeTimecardFn();
      getEmployeeScheduleFn();
    });
  }

  const handleCloseEmployee = () => {
    setEditEmployee({});
    setManageEmployee(false);
  };

  const startDeleteTimeEntry = (entry) => {
    let confirmation = {
      title: 'Archive Time Entry?',
      message: 'Confirm archive entry starting at ' + formatDate(entry.startDate) + ' ' + formatTime(entry.startDate) + '?',
      entity: entry
    }
    setConfirmation(confirmation);

    setTimeEntry(entry);
    setDeleteTimeEntry(true);
  }

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [hasStartDate, setHasStartDate] = useState(false);
  const [hasEndDate, setHasEndDate] = useState(false);

  const clockIn = () => {
    let _timeEntry = {
      startDate: new Date(),
    }
    handleSaveTimeEntry(_timeEntry);
  };

  const clockOut = (entry) => {
    let _timeEntry = {...entry};
    _timeEntry.timeEntryId = entry.id;
    _timeEntry.endDate = new Date();

    handleSaveTimeEntry(_timeEntry);
  };

  return (
    <DashboardLayout>

      <Meta
        pageTitle={'View Employee' + (employee?.firstName ? ' - ' : '') + (employee?.firstName || '') + ' ' + (employee?.lastName || '')}/>

      <ContextSearchNavbar title={'View Employee'}/>

      <MDBox py={3}>
        <Grid container spacing={3} cols={2}>
          <Grid item xs={12} sm={6}>
            {employee && <>
              <Card>
                <MDBox p={3}>
                  <h5 className={'mb-3'}>
                    {employee.backgroundColor && <span style={{
                      background: employee.backgroundColor,
                      width: '15px',
                      height: '15px',
                      float: 'left',
                      margin: '4px 6px 2px 0'
                    }}>
                  </span>}{employee?.firstName} {employee?.lastName}
                    <MDButton
                      size="small"
                      color="secondary"
                      className={'pull-right'}
                      onClick={(e) => {
                        startManageEmployeeFn(employee);
                      }}><Icon>edit</Icon>&nbsp; Edit</MDButton>
                  </h5>
                  <p>{employee.address1} {employee.address2}
                    <br/>{employee.city}, {employee?.state?.stateName} {employee.zipCode}
                    <br/>{employee.primaryPhone}
                  </p>

                  {employee?.employeeStartDate && <p>
                    <small className={'ml-2'}>Hired: {formatDate(employee?.employeeStartDate)}</small>
                  </p>
                  }

                </MDBox>
              </Card>

              {companyExtApplication?.connected && <>
                <Card className={'mt-2'}>
                  <MDBox p={3}>
                    <MDTypography variant="h5" fontWeight="regular" className={'mb-3'}>
                      <MDButton className={'mt-2 pull-right mx-2'}
                                type="button"
                                size={'small'}
                                onClick={() => {
                                  setManageHomeLocation(true);
                                }}
                                color="primary">
                        Set Home Location
                      </MDButton>
                      Home Location
                    </MDTypography>
                    {employee?.homeLocationName && <p>
                      {employee?.homeLocationName}</p>}
                    {!employee?.homeLocationName && <p>
                      None
                    </p>}
                  </MDBox>
                </Card>
              </>
              }

            </>}

          </Grid>
          <Grid item xs={12} sm={6}>
            <Card>
              <MDBox p={3}>
                <MDTypography variant="h5" fontWeight="regular" className={'mb-3'}>
                  {!simpleTimeEntry && <MDButton
                    size="small"
                    color="secondary"
                    className={'pull-right'}
                    onClick={(e) => {
                      addTimeEntry(e, false);
                    }}><Icon>add_circle</Icon>&nbsp; Add Time</MDButton>
                  }

                  {simpleTimeEntry && <>
                    <MDButton
                      size="small"
                      color="info"
                      disabled={hasStartDate}
                      className={'pull-right mx-1'}
                      onClick={(e) => {
                        clockIn()
                      }}>Clock In</MDButton>

                  </>
                  }

                  Time Clock
                </MDTypography>

                <MDButton
                  variant="outlined"
                  color="secondary"
                  size="small"
                  ref={el => (myRefs.current['timeEntryOptions'] = el)}
                  onClick={(e) => {
                    refHandler('timeEntryOptions')
                  }}>

                  {timeRequest?.label}

                  &nbsp;<span className={'fa fa-caret-down ml-2 mt-n1'}/>

                  {renderIndex && myRefs.current['timeEntryOptions']?.visible &&
                    <Menu open={true} anchorReference={null} anchorEl={myRefs.current['timeEntryOptions']}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}>
                      {timeEntryOptions.map((option, index) => {
                        return (
                          <NotificationItem key={index}
                                            onClick={(e) => {
                                              setTimeRequest(option)
                                            }} icon={
                            <Icon>{option.type === 'month' ? 'calendar_month' : 'access_time'}</Icon>}
                                            title={option.label}
                          />
                        )
                      })}
                    </Menu>
                  }

                </MDButton>
                <Divider/>
                <ul className={'list-group'}>
                  {timecard?.timecardEntryList?.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()).map((entry, index) => {
                    return (
                      <li
                        className={'list-group-item'}
                        key={index}>
                        {companyAdmin && <MDButton
                          style={{
                            marginRight: '8px'
                          }}
                          variant="outlined"
                          size={'small'}
                          className={'pull-left'}
                          color="info"
                          circular
                          iconOnly
                          onClick={(e) => {
                            startDeleteTimeEntry(entry)
                          }}><Icon>delete</Icon></MDButton>}

                        {formatDate(entry.startDate) + ' ' + formatTime(entry.startDate)}
                        {entry?.endDate && <>{' - '}{formatTime(entry?.endDate)}</>}
                        {!entry?.endDate && <>
                          <MDButton
                            size="small"
                            color="info"
                            className={'pull-right'}
                            onClick={(e) => {
                              clockOut(entry)
                            }}>Clock Out</MDButton>
                        </>}
                        {simpleTimeEntries && <>
                          {(companyAdmin && canEdit(entry)) && <MDButton variant="gradient"
                                                                         size={'small'}
                                                                         className={'pull-right'}
                                                                         color="info"
                                                                         onClick={(e) => {
                                                                           setTimeEntry(entry);
                                                                           setManageTimeEntry(true);
                                                                         }}>Edit</MDButton>}

                        </>}
                        {!simpleTimeEntries && <>
                          {canEdit(entry) && <MDButton variant="gradient"
                                                       size={'small'}
                                                       className={'pull-right'}
                                                       color="info"
                                                       onClick={(e) => {
                                                         setTimeEntry(entry);
                                                         setManageTimeEntry(true);
                                                       }}>Edit</MDButton>}

                        </>}
                      </li>
                    );
                  })}
                </ul>
              </MDBox>
            </Card>


            <Card className={'mt-2'}>
              <MDBox p={3}>
                <MDTypography variant="h5" fontWeight="regular" className={'mb-3'}>
                  <MDButton
                    size="small"
                    color="secondary"
                    className={'pull-right'}
                    onClick={(e) => {
                      addTimeEntry(e, true);
                    }}><Icon>add_circle</Icon>&nbsp; Add Schedule</MDButton>
                  Upcoming Schedule
                </MDTypography>

                <MDButton
                  variant="outlined"
                  color="secondary"
                  size="small"
                  ref={el => (myRefs.current['scheduleOptions'] = el)}
                  onClick={(e) => {
                    refHandler('scheduleOptions')
                  }}>

                  {scheduleRequest?.label}

                  &nbsp;<span className={'fa fa-caret-down ml-2 mt-n1'}/>

                  {renderIndex && myRefs.current['scheduleOptions']?.visible &&
                    <Menu open={true} anchorReference={null} anchorEl={myRefs.current['scheduleOptions']}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}>
                      {scheduleOptions.map((option, index) => {
                        return (
                          <NotificationItem key={index}
                                            onClick={(e) => {
                                              setScheduleRequest(option)
                                            }} icon={
                            <Icon>{option.type === 'month' ? 'calendar_month' : 'access_time'}</Icon>}
                                            title={option.label}
                          />
                        )
                      })}
                    </Menu>
                  }

                </MDButton>
                <Divider/>
                <ul className={'list-group'}>
                  {schedule?.timecardEntryList?.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()).map((entry, index) => {
                    return (
                      <li
                        className={'list-group-item'}
                        key={index}>

                        {companyAdmin && <MDButton
                          style={{
                            marginRight: '8px'
                          }}
                          variant="outlined"
                          size={'small'}
                          className={'pull-left'}
                          color="info"
                          circular
                          iconOnly
                          onClick={(e) => {
                            startDeleteTimeEntry(entry)
                          }}><Icon>delete</Icon></MDButton>}

                        {formatDate(entry.startDate) + ' ' + formatTime(entry.startDate)} - {formatTime(entry?.endDate)}

                        {canEdit(entry) && <MDButton variant="gradient"
                                                     size={'small'}
                                                     className={'pull-right'}
                                                     color="info"
                                                     onClick={(e) => {
                                                       let _e = {...entry}
                                                       _e.scheduledTime = true;
                                                       setTimeEntry(_e);
                                                       setManageTimeEntry(true);
                                                     }}>Edit</MDButton>}
                      </li>
                    );
                  })}
                </ul>
              </MDBox>
            </Card>

          </Grid>
        </Grid>
      </MDBox>

      {manageTimeEntry && <ManageTimeEntryModal
        timeEntry={timeEntry}
        show={manageTimeEntry}
        saving={saving}
        handleSave={handleSaveTimeEntry}
        handleClose={handleCloseTimeEntry}/>
      }

      {
        <>

          {editEmployee && <ManageEmployeeModal
            employee={editEmployee}
            show={manageEmployee}
            saving={saving}
            handleSaveEmployee={handleSaveEmployee}
            handleClose={handleCloseEmployee}/>
          }

        </>
      }

      {deleteTimeEntry && timeEntry && <Confirm confirmation={confirmation}
                                                show={deleteTimeEntry}
                                                saving={saving}
                                                handleConfirm={() => {
                                                  setSaving(true)
                                                  handleDeleteTimeEntry(timeEntry)
                                                }}
                                                handleSave={() => {
                                                  setDeleteTimeEntry(false);
                                                  setConfirmation(null);
                                                }}/>}

      {manageHomeLocation && <MangeSquareHomeLocation
        show={manageHomeLocation}
        employee={employee}
        handleClose={() => {
          setManageHomeLocation(false);
        }}
        handleSave={(e) => {
          let _context = {...context};
          const toastMessage = 'Home Location successfully saved.';
          _context.toast = {
            message: toastMessage,
            type: 'success'
          }
          setContext({..._context});
          setManageHomeLocation(false);
          getCompanyExtAppData();
        }}
      />}

      <Footer mt={5}/>

    </DashboardLayout>
  );
}